

































import { Vue, Component, Prop } from "vue-property-decorator";
import CloseBtn from '../../../share/common/CloseBtn.vue';

@Component({
    name: 'DarkModalWindow',
    components: { CloseBtn }
})
export default class Modal extends Vue {
    @Prop({default: false}) hideClose: boolean;
    @Prop({default: 'auto'}) width: string;
    @Prop({default: 'auto'}) minHeight: string;
    @Prop({ default: true }) needSlotLayout: boolean;
    @Prop({ default: true }) needBottom: boolean;
    @Prop({ default: true }) overflowIsAuto: boolean;
}
